<template>
  <div class="navigation-tabs">
    <div class="tabs-container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationTabs'
}
</script>

<style lang="sass" scoped>
@import '@/variables.sass'

.navigation-tabs
  background: white
  border-bottom: 1px solid $primary

.tabs-container
  display: flex
  align-items: center
  max-width: 100%
  overflow-x: auto

::v-deep .tab-item,
::v-deep a
  display: flex
  align-items: center
  padding: 10px 20px

  text-decoration: none
  font-weight: 500
  font-size: 14px
  border-bottom: 3px solid transparent
  transition: all 0.3s ease
  white-space: nowrap
  min-height: 48px
  user-select: none
  position: relative
  color: black !important

  &:hover
    color: $primary
    background-color: rgba(25, 118, 210, 0.04)

  &.router-link-active
    color: $primary !important
    border-bottom-color: $primary !important
    background-color: rgba(25, 118, 210, 0.04)

  &:first-child
    margin-left: 0

  &:last-child
    margin-right: 0

::v-deep .tab-item.disabled
  opacity: 0.5
  cursor: not-allowed
  color: #666 !important
  background-color: transparent
  border-bottom-color: transparent

::v-deep a.disabled
  opacity: 0.5
  cursor: not-allowed
  pointer-events: none
  color: #666 !important
  background-color: transparent
  border-bottom-color: transparent

// Responsive design
@media (max-width: 768px)
  .tabs-container
    flex-wrap: nowrap
    overflow-x: auto
    -webkit-overflow-scrolling: touch

  ::v-deep .tab-item,
  ::v-deep a
    padding: 10px 16px
    font-size: 13px
    min-width: fit-content

  ::v-deep .tab-item.disabled,
  ::v-deep a.disabled
    cursor: not-allowed
</style>
